import { Link } from 'react-router-dom';
import Icon from './Icon';
import { colors } from '../styles/theme';

function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.inner}>
        <p style={styles.brand}><Icon name="home" size={22} /> SooPooDing</p>
        <p style={styles.desc}>AI 기반 청약 맞춤 추천 서비스</p>
        <nav style={styles.links} aria-label="바닥글 메뉴">
          <Link to="/privacy" style={styles.link}>개인정보처리방침</Link>
          <span style={styles.divider} aria-hidden="true" />
          <Link to="/terms" style={styles.link}>이용약관</Link>
          <span style={styles.divider} aria-hidden="true" />
          <Link to="/guide" style={styles.link}>이용가이드</Link>
          <span style={styles.divider} aria-hidden="true" />
          <Link to="/report" style={styles.link}>오류신고</Link>
        </nav>
        <p style={styles.copy}>© 2026 SooPooDing. All rights reserved.</p>
        <p style={styles.disclaimer}>
          본 서비스의 청약 정보는 참고용이며 실제 청약은 청약홈(applyhome.co.kr)에서 확인하세요.
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: { background: colors.primary, padding: '32px 16px', marginTop: '40px' },
  inner: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  brand: { color: colors.white, fontSize: '18px', fontWeight: 'bold', margin: '0 0 6px' },
  desc: { color: colors.grey500, fontSize: '13px', margin: '0 0 16px' },
  links: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    gap: '8px', flexWrap: 'wrap', marginBottom: '16px',
  },
  link: {
    color: colors.grey400, fontSize: '13px', textDecoration: 'underline',
    padding: '6px 4px', display: 'inline-block',
  },
  // 파이프 문자 대신 실제 선. 글리프는 폰트마다 높이·굵기가 달라 링크 사이에서 튄다.
  divider: { display: 'inline-block', width: '1px', height: '12px', background: colors.grey400, verticalAlign: 'middle' },
  copy: { color: colors.grey500, fontSize: '12px', margin: '0 0 8px' },
  disclaimer: { color: colors.grey500, fontSize: '12px', margin: 0 },
};

export default Footer;
